import React, { createContext, useMemo, useContext } from 'react';

import { ChildrenPropType } from '../../../../prop-types/children';
import { usePaymentAndSubscriptionMegaContext } from '../context';

const PaymentAndSubscriptionPageContext = createContext({});

export const usePaymentAndSubscriptionPageContext = () => useContext(PaymentAndSubscriptionPageContext);

export const PaymentAndSubscriptionPageContextProvider = ({ children }) => {
  const {
    billingInfo,
    setBillingInfo,
    setDesiredNumberOfAdditionalUsers,
    desiredNumberOfAdditionalUsers,
    setBillingInfoErrorType,
    billingInfoErrorType,
    reloadData,
    is3plPlanEnabled,
    setIs3plPlanEnabled,
    isBillingEmailModalOpen,
    setIsBillingEmailModalOpen,
    isCancellationModalOpen,
    setIsCancellationModalOpen,
    currentPage,
    setCurrentPage,
    comments,
    setComments,
    followUpExplain,
    setFollowUpExplain,
    cancelReasonId,
    setCancelReasonId,
    sellerStampsProviders,
    setSellerStampsProviders,
    errorDuring3plPlanRemoval,
    cancellationInfo,
    setCancellationInfo,
    cancelSubscriptionCall,
    followUpCancelReasonId,
    setFollowUpCancelReasonId,
    isPlanInfoLoading,
    isSubscriptionDataLoading,
    isBillingInfoLoading,
    paymentMethodDetails,
    isPaymentSummaryListLoading,
    setIsPaymentSummaryListLoading,
  } = usePaymentAndSubscriptionMegaContext();

  const value = useMemo(
    () => ({
      billingInfo,
      setBillingInfo,
      billingInfoErrorType,
      setBillingInfoErrorType,
      desiredNumberOfAdditionalUsers,
      setDesiredNumberOfAdditionalUsers,
      reloadData,
      is3plPlanEnabled,
      setIs3plPlanEnabled,
      isBillingEmailModalOpen,
      setIsBillingEmailModalOpen,
      isCancellationModalOpen,
      setIsCancellationModalOpen,
      currentPage,
      setCurrentPage,
      comments,
      setComments,
      followUpExplain,
      setFollowUpExplain,
      cancelReasonId,
      setCancelReasonId,
      sellerStampsProviders,
      setSellerStampsProviders,
      errorDuring3plPlanRemoval,
      cancellationInfo,
      setCancellationInfo,
      cancelSubscriptionCall,
      followUpCancelReasonId,
      setFollowUpCancelReasonId,
      isPlanInfoLoading,
      isSubscriptionDataLoading,
      isBillingInfoLoading,
      paymentMethodDetails,
      isPaymentSummaryListLoading,
      setIsPaymentSummaryListLoading,
    }),
    [
      billingInfo,
      setBillingInfo,
      billingInfoErrorType,
      setBillingInfoErrorType,
      desiredNumberOfAdditionalUsers,
      setDesiredNumberOfAdditionalUsers,
      reloadData,
      is3plPlanEnabled,
      setIs3plPlanEnabled,
      isBillingEmailModalOpen,
      setIsBillingEmailModalOpen,
      isCancellationModalOpen,
      setIsCancellationModalOpen,
      currentPage,
      setCurrentPage,
      comments,
      setComments,
      followUpExplain,
      setFollowUpExplain,
      cancelReasonId,
      setCancelReasonId,
      sellerStampsProviders,
      setSellerStampsProviders,
      errorDuring3plPlanRemoval,
      cancellationInfo,
      setCancellationInfo,
      cancelSubscriptionCall,
      followUpCancelReasonId,
      setFollowUpCancelReasonId,
      isPlanInfoLoading,
      isSubscriptionDataLoading,
      isBillingInfoLoading,
      paymentMethodDetails,
      isPaymentSummaryListLoading,
      setIsPaymentSummaryListLoading,
    ],
  );

  return <PaymentAndSubscriptionPageContext.Provider value={value}>{children}</PaymentAndSubscriptionPageContext.Provider>;
};

PaymentAndSubscriptionPageContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};

export { PaymentAndSubscriptionPageContext };
